import { createSelector } from 'reselect'
import CONFIG from 'config'

const getHomeInfoState = state => state.homeInfo

export const getHomeInfo = createSelector(
  [getHomeInfoState],
  homeInfo => {
    if (homeInfo && homeInfo.data) {
      return homeInfo.data.map(data => ({
        image: CONFIG.CONTENT_CDN_BASE_URL + data.hinfoMainImage,
        alternText: data.hinfoAltText,
        title: data.title,
        buttonText: data.hinfoSeeMoreButton,
        url: data.hinfoSeeMoreUrl && data.hinfoSeeMoreUrl.replace(/&amp;/g, `&`),
        items: (data.hinfoItemReference || []).map(item => ({
          title: item.title,
          alternText: item.hinfo_icon_alt_text,
          icon: CONFIG.CONTENT_CDN_BASE_URL + item.hinfo_icon_image,
          iconName: item.hinfo_icon_name,
          iconUrl: item.hinfo_icon_url && item.hinfo_icon_url.replace(/&amp;/g, `&`)
        }))
      }))
    }

    return []
  }
)
